package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

data class ExposureStepContext(
    val state: ProgressiveExposureState,
    val renderer: ExposureTextRenderer,
)
